import { render, staticRenderFns } from "./UserCabinetSubmenu.vue?vue&type=template&id=577a361c&scoped=true"
import script from "./UserCabinetSubmenu.vue?vue&type=script&lang=js"
export * from "./UserCabinetSubmenu.vue?vue&type=script&lang=js"
import style0 from "./UserCabinetSubmenu.vue?vue&type=style&index=0&id=577a361c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577a361c",
  null
  
)

export default component.exports